import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
interface GxTertiaryButtonProps {
  onClick: () => void;
  children?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";

  loadingLabel?: string;
}
const GxDeleteRedButton: React.FC<GxTertiaryButtonProps> = ({
  onClick,
  children,
  loading = false,
  disabled = false,
  type = "button",
  loadingLabel,
}) => {
  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || loading}
      type={type}
      className="gx-dialog-deletered-button"
    >
      {loading && (
        <Loader
          type="pulsing"
          themeColor="error"
          size="small"
          className="mr-2"
        />
      )}
      <span className="gx-p14-sb">{getButtonText()}</span>
    </button>
  );
};

export default GxDeleteRedButton;
